// The authenticator-code input, the same wherever a code is asked for (sign-in, enrolment,
// step-up): six digits, and the browser offers the one-time code it was sent.
import { Field, FieldDescription, FieldLabel } from "@/components/ui/field";
import { Input } from "@/components/ui/input";
import { m } from "@/lib/paraglide/messages.js";

export function CodeField({
  id,
  value,
  onChange,
  description,
}: {
  id: string;
  value: string;
  onChange: (code: string) => void;
  /** Why the code is asked for, under the input. */
  description?: string;
}) {
  return (
    <Field>
      <FieldLabel htmlFor={id}>{m.staff_code()}</FieldLabel>
      <Input
        id={id}
        inputMode="numeric"
        autoComplete="one-time-code"
        maxLength={6}
        value={value}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, ""))}
      />
      {description && <FieldDescription>{description}</FieldDescription>}
    </Field>
  );
}
